import React from 'react'
// import './Mutual.css'
import insuranceimg from '../../../assets/insuranceimg.avif'
import img2 from "../../../assets/img2.jpg";
import client2 from "../../../assets/client2.jpg";
import Footer from '../../../general/footer/Footer';
import { Link } from 'react-router-dom';


const Insurance = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Insurance</span>
                    </div>
                    <h1>Insurance</h1>
                    <p>
                        At PSJ Capital Ventures, we help you choose insurance policies that align with your goals, needs, and risk exposure, powered by unbiased advice and deep market research.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={insuranceimg} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>What Is Insurance?</h2>
                    <p>
                        Insurance is a contract between you and an insurer that protects you against financial loss. In return for a premium, the insurer commits to covering specific risks such as health emergencies, accidents, or loss of life and property. The right insurance strategy is a key pillar in long-term financial planning.
                    </p>
                    <h3 style={{ color: 'black' }}>Why Insurance Matters</h3>
                    <p className="bold-line">
                        Life is unpredictable, but your financial future doesn’t have to be. Insurance provides a cushion against unexpected disruptions, ensuring peace of mind and continuity for you and your loved ones. From health to business coverage, it’s more than a backup. It’s a smart, proactive investment in risk management.
                    </p>

                    <h3 style={{ color: 'black' }}>Key Terminologies</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 	Premium: </h5>
                            <p>The amount paid (monthly, quarterly, or annually) to keep an insurance policy active.
                            </p>
                            <h5>2. 		Sum Assured: </h5>
                            <p>The guaranteed amount paid to the insured or nominee in case of a claim.</p>
                        </div>
                        <div>
                            <h5>3. 		Riders: </h5>
                            <p>Optional add-ons to enhance your base insurance coverage.</p>
                            <h5>4. 		Claim Settlement Ratio: </h5>
                            <p>A key metric that shows how reliably an insurer settles claims.</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Our Insurance Offerings</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 		Life Insurance  </li>
                                <li>✓ 		Health Insurance  </li>
                                <li>✓ 		Personal Accident & Disability  </li>
                                <li> ✓		Business Insurance  </li>
                                <li> ✓  	Travel & Property Insurance  </li>
                            </ul>
                        </div>
                    </div>

                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Benefits of Insurance Planning</h3>

                        <ul>
                            <li>✓ 		Financial Protection</li>
                            <li>✓ 	    Peace of Mind</li>
                            <li>✓ 		Tax Benefits</li>
                            <li>✓ 		Legacy Planning</li>
                            <li>✓ 		Customized Coverage</li>
                        </ul>

                        <h3>Why Clients Choose Us</h3>

                        <ul>
                            <li>Needs-Based Analysis </li>
                            <li>Insurer Comparison </li>
                            <li>End-to-End Advisory </li>
                            <li>Smart Structuring </li>
                        </ul>

                        <p>
                            Let’s Build Your Insurance Safety Net
                            Explore coverage options or speak with our advisory team to build a protection plan that truly fits. At PSJ Capital Ventures, insurance is not just a product, it’s part of your long-term strategy.

                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>Mutual Funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication →</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default Insurance